// assets
import { PlusCircleFilled } from "@ant-design/icons";
import { CheckOutlined } from "@ant-design/icons";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";

import { getInitials, initialsAvatarSx } from "@/pages/utils/avatarDisplay";

import ProductButton from "./ProductButton";

type ProductsMenuProps = {
  drawerOpen: boolean;
  productName?: string;
  productIconLink?: string;
  disableSelect?: boolean;
};

export default function ProductsMenu({
  drawerOpen,
  productName,
  productIconLink,
  disableSelect,
}: ProductsMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedProduct] = React.useState<string | null>(productName || null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        padding: 0,
        marginTop: drawerOpen ? "8px" : "24px",
        marginBottom: drawerOpen ? "4px" : "16px",
        background: open ? "rgba(0, 0, 0, 0.04)" : "none",
        borderRadius: "8px",
      }}
    >
      <ProductButton
        drawerOpen={drawerOpen}
        dropdownOpen={open}
        productName={productName || ""}
        productIconLink={productIconLink || ""}
        onClick={handleClick}
        onMouseOver={handleClick}
        disableSelect={disableSelect}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "12px",
            boxShadow:
              "0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)",
            padding: "8px 0px",
            width: "226px",
            backgroundColor: "common.white",
            color: "text.primary",
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          onMouseLeave: handleClose,
        }}
      >
        <MenuItem
          selected
          onClick={handleClose}
          sx={{
            "&.Mui-selected": {
              backgroundColor: "transparent !important",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <ListItemIcon>
            <Avatar
              src={productIconLink}
              alt="avatar"
              variant="rounded"
              sx={{
                width: 36,
                height: 36,
                mr: "10px",
                borderRadius: "9.6px",
                border: "1px solid #F0F0F0",
                ...initialsAvatarSx(36),
              }}
            >
              {getInitials(productName)}
            </Avatar>
          </ListItemIcon>
          <ListItemText>
            {selectedProduct ? (
              <Typography sx={{ fontWeight: 700 }}>
                {productName}
                <CheckOutlined style={{ marginLeft: "10px" }} />
              </Typography>
            ) : (
              productName
            )}
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <PlusCircleFilled
              style={{ fontSize: "24px", marginRight: "10px", marginLeft: "6px" }}
            />
          </ListItemIcon>
          <ListItemText>Add product</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
